<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="月扣费设置"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
      :selectable="selectable"
      >
      <!-- bar-tip="注：开通增值套餐的学校，在开通周期内，如果该月份既需要扣除增值套餐的低消，又需要扣除基础套餐的低消的，则添加一条类型为“话费”的扣费记录。如果该月份只需要扣除增值套餐的低消（例如假期），则添加一条类型为“增值话费”的扣费记录。未开通增值套餐的学校，则依然需要在扣除低消的月份，添加一条类型为“话费”的扣费记录。另外，相同学校相同月份，只能设置增值话费或话费其中一种" -->
    
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <!-- <el-form-item label="学校名称">
          <el-select size="mini" v-model="params.SchoolId" clearable @change="query()">
            <el-option v-for="item in schoolList" :key="item.SchoolId" :value="item.SchoolId" :label="item.SchoolName"></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item label="学校">
          <el-select size="mini" v-model="params.SchoolId" clearable @change="query()">
            <el-option
              v-for="(i,key) in schools"
              :key="key"
              :value="i.SchoolId"
              :label="i.SchoolName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分组">
          <el-input size="mini" v-model="params.GroupName" placeholder="请输入分组" clearable />
        </el-form-item>
        <el-form-item label="所属月份" :class="isMB?'rentMon':''">
          <el-date-picker
            v-model="params.date"
            type="monthrange"
            align="right"
            unlink-panels
            @change="setDate"
            range-separator="至"
            value-format="yyyy-MM"
            size="mini"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            style="width:300px;"
          ></el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="类型">
          <el-select size="mini" v-model="params.Kind" clearable>
            <el-option value="话费"/>
            <el-option value="赠送"/>
            <el-option value="增值话费"/>
          </el-select>
        </el-form-item> -->
      </template>
      <template slot="table">
        <el-table-column prop="SchoolName" label="学校" min-width="150" show-overflow-tooltip />
        <el-table-column prop="GroupName" label="分组" min-width="150" show-overflow-tooltip />
        <el-table-column prop="RentMon" label="所属月份" min-width="110" />
        <el-table-column prop="WaitTime" label="预约扣费/赠送时间" min-width="130">
          <template slot-scope="{row}">
            <span>{{row.WaitTime?(row.WaitTime.split(":")[0] + ':' + row.WaitTime.split(":")[1]):''}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="NotifyTime" label="扣费成功通知时间" min-width="130">
          <template slot-scope="{row}">
            <span>{{row.NotifyTime?(row.NotifyTime.split(":")[0] + ':' + row.NotifyTime.split(":")[1]):''}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="FinishTime" label="完成扣费/赠送时间" min-width="140" />
        <el-table-column prop="Kind" label="类型" min-width="90" />
        <el-table-column label="扣费状态" width="90" align="center">
          <template slot-scope="{row}">
            <el-tag type="primary" v-if="row.Status=='待扣费'||row.Status=='待执行'">待执行</el-tag>
            <el-tag type="danger" v-else-if="row.Status=='已扣费'||row.Status=='已执行'">已执行</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="通知状态" width="90" align="center">
          <template slot-scope="{row}">
            <el-tag type="primary" v-if="row.NotifyStatus=='待通知'">待通知</el-tag>
            <el-tag type="success" v-else-if="row.NotifyStatus=='已通知'">已通知</el-tag>
          </template>
        </el-table-column>-->
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/consume/rentmon").default,
      school_api: require("@/api/st/school").default,
      params: {
        SchoolId: null,
        StartDate: "",
        EndDate: "",
        date: "",
        // Kind: "",
      },
      schools: [],
      groups:[],
      isMB: this.$store.state.isMB,
    };
  },
  beforeMount() {
    this.school_api.list({ Status: 1 }).then((res) => {
      if (res.Code == 0) this.schools = res.Data;
    });
  },
  methods: {
    setDate(date) {
      if (date) {
        this.params.StartDate = date[0];
        this.params.EndDate = date[1];
      } else {
        this.params.StartDate = "";
        this.params.EndDate = "";
      }
    },
    selectable(row) {
      if (row.Status != "已扣费") {
        return true;
      } else {
        return false;
      }
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
  },
};
</script>
<style lang="scss">
.rentMon {
  .el-form-item__content {
    width: 100%;
    text-align: center;
  }
}
</style>